<div class="row mb-2">
    <div class="col-md-6">
        <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control"
                placeholder="Search by monthly trips" style="width: 70%"> </div>
    </div>

    <div class="col-md-6 m-0 text-end">
      <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
         Export Current Excel  </button>
         <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
          Export All Excel </button>
    </div>
</div>


<div class="main-card mb-3 card">
    <div class="card-header font-weight-B fs-1r">
      All Quote Enterprise Requests 
    </div>
    <div class="table-responsive">
      <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
        <thead>
        <tr>
          <th> Person Name</th>
          <th>Company Name</th>
          <th>Mobile</th>
          <th>Email</th>
          <th>Monthly Trips</th>
          <th>Designation</th>
          <th class="text-end">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of allQuoteEnterpriseList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
          <!-- <td class="text-left text-muted">#345</td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.personName}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.companyName}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.mobile}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.email}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.monthlyTrips}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.designation}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td> 
          <td class="text-end">
            <div class="dropdown">
              <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="viewDetails(content1 ,data)">View Details <i class="fa fa-eye"></i></a></li>
              </ul>
            </div>
          </td>
        </tr>
       
        </tbody>
        <div *ngIf="allQuoteEnterpriseList?.length  == 0" class="text-center mt-5 mb-5" >
          <span class="text-danger">Data Not found</span>
        </div>
        
      </table>
      <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->
      <ngb-pagination
    (pageChange)="gty((page = $event))"
    [collectionSize]="totalItems"
    [(page)]="page"
    [pageSize]="itemsPerPage"
    [maxSize]="3"
    [rotate]="true"
    [boundaryLinks]="false"
  >
  </ngb-pagination>
    </div>
  </div>


  
  <div class="card-body">
    <ng-template #content1 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-eye"></i> View Details   </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body">
     
        <div class="row">
          <div class="col-md-1"></div>  
                <div class="col-md-10 ">
                  <label for="">ID : </label>
                  <input type="text"   [ngModel]="viewAllData?._id"  [disabled]="true" class="form-control">
               </div>
                  <div class="col-md-1"></div>

          <div class="col-md-1"></div>  
          <div class="col-md-5 mt-2">
            <label for="">Person Name : </label>
            <input type="text"   [ngModel]="viewAllData?.personName"  [disabled]="true" class="form-control">
         </div>
         <div class="col-md-5 mt-2">
            <label for="">Company Name : </label>
            <input type="text"  [ngModel]="viewAllData?.companyName"  [disabled]="true" class="form-control">
         </div>
         <div class="col-md-1"></div>

         <div class="col-md-1"></div>  
          <div class="col-md-5 mt-2">
            <label for="">Mobile : </label>
            <input type="text"   [ngModel]="viewAllData?.mobile"  [disabled]="true" class="form-control">
         </div>
         <div class="col-md-5 mt-2">
             <label for="">Email : </label>
             <input type="text"  [ngModel]="viewAllData?.email"  [disabled]="true" class="form-control">
            </div>
            <div class="col-md-1"></div>

           
              <div class="col-md-1"></div>  
              <div class="col-md-5 mt-2">
                <label for="">Monthly Trips : </label>
                <input type="text"   [ngModel]="viewAllData?.monthlyTrips"  [disabled]="true" class="form-control">
             </div>
             <div class="col-md-5 mt-2">
                <label for="">Designation : </label>
                <input type="text"   [ngModel]="viewAllData?.designation"  [disabled]="true" class="form-control">    
            </div>
                <div class="col-md-1"></div>

                <div class="col-md-1"></div>  
                <div class="col-md-5 mt-2 mb-4">
             
                  <label for="">Status : </label>
                  <input type="text"  [ngModel]="viewAllData?.status == 1 ? 'Active' : 'Inactive'"  [disabled]="true" class="form-control">
               
               </div>
               <div class="col-md-5 mt-2 mb-4">
                <label for="">Created On : </label>
                <input type="text"   [ngModel]="viewAllData?.createdOn | date:'dd MMM yyyy hh:mm a'"  [disabled]="true" class="form-control">
             </div>
                  <div class="col-md-1"></div>

              
        </div>
      </div>
    </ng-template>
  </div>